import axios from "axios"


export let accessToken = ""
export let refreshToken = ""

export function setToken(data){
  accessToken = data.accessToken
  refreshToken = data.refreshToken
}

axios.interceptors.request.use(
  request => {
    if(accessToken){
      request.headers["Authorization"] = `Bearer ${accessToken}`
    }
    return request
  },

)
